import Notification from "@/assets/Helper/Notification";

class Logger {

    constructor() {
        this.consoleOutput = !!(process.env.VUE_APP_DEBUG_MODE);
        this.slackPushUrl = (typeof process.env.VUE_APP_JS_LOGGER_SLACK_PUSH === 'string') ? process.env.VUE_APP_JS_LOGGER_SLACK_PUSH : false;
    }

    log(value, outputType) {
        if (typeof outputType !== 'string' && outputType !== 'debug' && outputType !== 'error' && outputType !== 'info') {
            outputType = 'log';
        }

        if (this.consoleOutput === true) {
            console[outputType](value);
        }
    }

    debug(value) {
        this.log(value, 'debug');
    }

    error(value, raw_response = "") {
        this.log(value, 'error');
        this.pushError({
            type: 'error',
            error: value
        }, raw_response);
    }

    info(value) {
        this.log(value, 'info');
    }

    vueError(error, vm, info) {
        this.pushError({
            type: 'error',
            error: error,
            vm: vm,
            info: info
        });
    }

    pushError(error, raw_response = "") {
        let isSlackPush = true;

        if (!error || (
            typeof error === 'object' && (
                !error.error || (
                typeof error.error === 'string' &&
                error.error !== '' && (
                    error.error.indexOf('NetworkError') > -1
                )
            )))
        ) {
            isSlackPush = false;
        }

        let message = {
            browser: {
                appName: navigator.appName,
                appCodeName: navigator.appCodeName,
                appVersion: navigator.appVersion,
                platform: navigator.platform,
                language: navigator.language,
                userAgent: navigator.userAgent
            },
            url: document.location.href,
            error: error
        };

        if (typeof this.slackPushUrl === 'string' && this.slackPushUrl !== '' && isSlackPush === true) {
            if (raw_response !== "") {
                raw_response = "\n\n```" + raw_response + "```"
            }

            fetch(this.slackPushUrl, {
                method: 'POST',
                body: JSON.stringify({
                    text: "```" + JSON.stringify(message, undefined, 4) + "```" + raw_response
                })
            }).catch(error => {
                console.error(error);
            });
        } else {
            console.error(error.error, error.info);
        }
        Notification.create('ERROR', error.error);
    }
}

export default new Logger();